<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="add-product">
        <el-form ref="form" label-position="left" label-width="140px" size="mini">
          <div class="product-title">首页视频</div>
          <el-form-item label="视频主图">
            <el-upload action="" class="upload-demo" :http-request="uploadSectionFile" :on-remove="handleSectionRemove"
                       :limit="1" :file-list="fileList" list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频">
            <el-upload action="" class="upload-demo" :http-request="uploadVideoUrlFile" :on-remove="handleVideoUrlRemove"
                       :limit="1" :file-list="fileList1" list-type="video">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item size="large">
            <el-button type="primary" @click="onSubmitVideo">提交</el-button>
          </el-form-item>
        </el-form>
        <el-form ref="form"  label-position="left" label-width="140px" size="mini">
          <div class="product-title">底部图片</div>
          <el-form-item label="底部图片">
            <el-upload action="" class="upload-demo" :http-request="uploadImgFile" :on-remove="handleImgRemove"
                       :limit="1" :file-list="fileList2" list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item size="large">
            <el-button type="primary" @click="onSubmitImg">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {Loading} from 'element-ui'
import {uploadFile1, indexVideoSubmit,indexBottomImgSubmit,getIndexVideo,getBottomImg} from 'api/request'
import {loadingInstance, Success,} from 'common/js/util'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
export default {
  data() {
    return {
      videoData:{
        coverUrl:null,
        videoUrl:null,
      },
      bottomImg:{
        url:null
      },
      fileList:[],
      fileList1:[],
      fileList2:[],
      beforeUrl:"https://qy-static.umeng.top/",
    }
  },
  components: {
    MSidebar,
    MHeader
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this.fileyHeader ={
        token:getUserInfo.token,
        'Content-Type': 'application/json;charset=utf-8'
      }
      this._getVideo();
      this._getBottomImg();
    }
  },
  methods: {
    _getVideo () {
      loadingInstance(Loading)
      getIndexVideo().then((res) => {
        loadingInstance(Loading).close()
        if (res.status === 200) {
          this.videoData.coverUrl = res.data.coverUrl;
          this.videoData.videoUrl = res.data.videoUrl;
          this.fileList.push({url: res.data.coverUrl});
          this.fileList1.push({url: res.data.videoUrl});
        } else {
          Error(this, res)
        }
      })
    },
    _getBottomImg () {
      loadingInstance(Loading)
      getBottomImg().then((res) => {
        loadingInstance(Loading).close()
        if (res.status === 200) {
          this.bottomImg.url = res.data.url;
          this.fileList2.push({url: res.data.url});
        } else {
          Error(this, res)
        }
      })
      console.log('this.bottomImg.url',this.bottomImg.url)
    },
    //提交视频
    // onSubmitVideo(){
    //   if(!this.videoData.coverUrl){
    //     this.$message('请上传视频主图');
    //   }else if(!this.videoData.videoUrl){
    //     this.$message('请上传视频');
    //   }else{
    //     indexVideoSubmit(this.videoData).then((res) => {
    //       if (res.status === 200) {
    //         Success(this, res)
    //       }
    //     })
    //   }
    // },
    onSubmitVideo() {
      // 从 coverUrl 和 videoUrl 中移除前缀
      let prefix = "https://qy-static.umeng.top/";
      if (this.videoData.coverUrl.startsWith(prefix)) {
        this.videoData.coverUrl = this.videoData.coverUrl.substring(
          prefix.length
        );
      }
      if (this.videoData.videoUrl.startsWith(prefix)) {
        this.videoData.videoUrl = this.videoData.videoUrl.substring(
          prefix.length
        );
      }

      // 剩余的提交逻辑
      if (!this.videoData.coverUrl) {
        this.$message("请上传视频主图");
      } else if (!this.videoData.videoUrl) {
        this.$message("请上传视频");
      } else {
        indexVideoSubmit(this.videoData).then(res => {
          if (res.status === 200) {
            Success(this, res);
          }
        });
      }
    },
    // 上传视频主图
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 401);
      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === 200) {
          this.videoData.coverUrl = res.data;
          this.fileList = [{url: this.beforeUrl+res.data}];
        } else {
          Error(this, res)
        }
      })
    },
    //删除视频主图
    handleSectionRemove(file, fileList) {
      if (fileList.length == 0) {
        this.videoData.coverUrl = "";
      }
    },
    // 上传视频
    uploadVideoUrlFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 402);
      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === 200) {
          this.videoData.videoUrl = res.data;
          this.fileList1 = [{url: this.beforeUrl+res.data}];
        } else {
          Error(this, res)
        }
      })
    },
    //删除视频
    handleVideoUrlRemove(file, fileList) {
      if (fileList.length == 0) {
        this.videoData.videoUrl = "";
      }
    },
    // 底部图片
    uploadImgFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 401);
      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === 200) {
          this.bottomImg.url = res.data;
          this.fileList2 = [{url: this.beforeUrl+res.data}];
        } else {
          Error(this, res)
        }
      })
    },
    //删除底部图片
    handleImgRemove(file, fileList) {
      if (fileList.length == 0) {
        this.bottomImg.url = "";
      }
    },
    //提交底部图片
    onSubmitImg() {
      // 从 url 中移除前缀
      let prefix = "https://qy-static.umeng.top/";
      if (this.bottomImg.url && this.bottomImg.url.startsWith(prefix)) {
        this.bottomImg.url = this.bottomImg.url.substring(prefix.length);
      }

      // 剩余的提交逻辑
      if (!this.bottomImg.url) {
        this.$message("请上传底部图片");
      } else {
        indexBottomImgSubmit(this.bottomImg).then(res => {
          if (res.status === 200) {
            Success(this, res);
          }
        });
      }
    }
    // onSubmitImg(){
    //   if(!this.bottomImg){
    //     this.$message('请上传底部图片');
    //   }else{
    //     indexBottomImgSubmit(this.bottomImg).then((res) => {
    //       if (res.status === 200) {
    //         Success(this, res)
    //       }
    //     })
    //   }
    // },
  },
}
</script>

<style scoped>
.add-product {
  height: fit-content;
  margin-left: 50px;
  margin-top: 30px;
  margin-bottom: 30px;
  box-sizing: border-box;
}
.product-title {
  width: 100%;
  display: inline-block;
  float: left;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #333333;
}

</style>



// WEBPACK FOOTER //
// src/components/system/indexManage.vue